import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import fr from "vuetify/lib/locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr },
    current: "fr",
  },
  icons: {
    iconfont: "fa",
  },
  theme: {
    themes: {
      light: {
        darkColor: "#00a3dd",
        primaryColor: "#38b7bd",
        altColor: "#fba822",
      },
    },
    options: { customProperties: true },
  },
});
